import {
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_COLOR2,
	DATAPOINT_BUTTON_FREQUENCY1,
	DATAPOINT_BUTTON_FREQUENCY2,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_LED_COLOR,
	DATAPOINT_LED_FREQUENCY,
	DATAPOINT_PIN1_FREQUENCY,
	DATAPOINT_PIN1_MODE,
	DATAPOINT_PIN1_STATUS,
	DATAPOINT_PIN2_FREQUENCY,
	DATAPOINT_PIN2_MODE,
	DATAPOINT_PIN2_STATUS,
	DATAPOINT_PIN3_FREQUENCY,
	DATAPOINT_PIN3_MODE,
	DATAPOINT_PIN3_STATUS,
	DATAPOINT_PIN4_FREQUENCY,
	DATAPOINT_PIN4_MODE,
	DATAPOINT_PIN4_STATUS,
	SBOX_TYPE,
	SLIGHT_TYPE,
	KISIO_TYPE
} from '../../../modules/common/consts';
export const DIGITAL_TWIN_DATAPOINTS_BY_TYPE: Record<string, string[]> = {
	[SBOX_TYPE]: [
		DATAPOINT_BUTTON_COLOR1,
		DATAPOINT_BUTTON_COLOR2,
		DATAPOINT_IS_ONLINE,
		DATAPOINT_BUTTON_FREQUENCY1,
		DATAPOINT_BUTTON_FREQUENCY2,
		DATAPOINT_PIN1_STATUS,
		DATAPOINT_PIN2_STATUS,
		DATAPOINT_PIN3_STATUS,
		DATAPOINT_PIN4_STATUS,
		DATAPOINT_PIN1_FREQUENCY,
		DATAPOINT_PIN2_FREQUENCY,
		DATAPOINT_PIN3_FREQUENCY,
		DATAPOINT_PIN4_FREQUENCY,
		DATAPOINT_PIN1_MODE,
		DATAPOINT_PIN2_MODE,
		DATAPOINT_PIN3_MODE,
		DATAPOINT_PIN4_MODE
	],
	[SLIGHT_TYPE]: [
		DATAPOINT_IS_ONLINE,
		DATAPOINT_LED_COLOR,
		DATAPOINT_LED_FREQUENCY,
		DATAPOINT_PIN1_STATUS,
		DATAPOINT_PIN2_STATUS,
		DATAPOINT_PIN3_STATUS,
		DATAPOINT_PIN4_STATUS,
		DATAPOINT_PIN1_FREQUENCY,
		DATAPOINT_PIN2_FREQUENCY,
		DATAPOINT_PIN3_FREQUENCY,
		DATAPOINT_PIN4_FREQUENCY,
		DATAPOINT_PIN1_MODE,
		DATAPOINT_PIN2_MODE,
		DATAPOINT_PIN3_MODE,
		DATAPOINT_PIN4_MODE
	],
	[KISIO_TYPE]: [
		DATAPOINT_IS_ONLINE,
		DATAPOINT_PIN1_STATUS,
		DATAPOINT_PIN2_STATUS,
		DATAPOINT_PIN3_STATUS,
		DATAPOINT_PIN4_STATUS,
		DATAPOINT_PIN1_FREQUENCY,
		DATAPOINT_PIN2_FREQUENCY,
		DATAPOINT_PIN3_FREQUENCY,
		DATAPOINT_PIN4_FREQUENCY,
		DATAPOINT_PIN1_MODE,
		DATAPOINT_PIN2_MODE,
		DATAPOINT_PIN3_MODE,
		DATAPOINT_PIN4_MODE
	]
};
